export default __webpack_public_path__ + "static/media/logo-wanaka.a87e504f.svg";